import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const NotFound = () => (
  <Layout>
    <Seo title="Sayfa bulunamadı" noindex />
    <section className="not-found">
      <div className="container">
        <div className="code">404</div>
        <h1>Sayfa bulunamadı</h1>
        <p className="lead">Aradığınız sayfa taşınmış ya da kaldırılmış olabilir.</p>
        <Link to="/" className="btn btn--primary">Ana sayfaya dön</Link>
      </div>
    </section>
  </Layout>
);

export default NotFound;
